var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-speed',
        type: 'meter',
        value: _vm.telemetry2.truck.speed,
        min: _vm.$convertToUnit(2.77778, 'unit_speed'),
        max: _vm.$convertToUnit(36.1111, 'unit_speed'),
        minAngle: -114.3,
        maxAngle: 114.8
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-engineRpm',
        type: 'meter',
        value: _vm.telemetry2.truck.rpm,
        min: 300,
        max: 2700,
        minAngle: -115,
        maxAngle: 113.6
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }